module.exports = __webpack_public_path__ + "img/corte-costituzionale-no-bg.31aca0cb.png";